import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Predictable turnaround",
      "Ideal for upcoming trips",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Appointment required — no walk-ins allowed",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service",
      "Good for planned travel",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Workload & wait times shift with shutdowns and budget fights",
      "In-person clerk appointment required",
      "No document review — errors cause rejection",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Can't upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
];

export default function LakewoodRanchProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Lakewood Ranch"
      headingExtra="FL"
      introText="Lakewood Ranch travelers have several options for getting an expedited passport. Here's how they compare — and why most residents of this master-planned community spanning Manatee and Sarasota counties choose a registered U.S. Department of State passport courier agency."
      options={options}
      emergencyDescription="Miami is approximately 230 miles via I-75 (4+ hours each way). Florida's single agency serves 22M+. Lakewood Ranch — one of America's largest master-planned communities — is home to thousands of retirees and professionals who travel internationally year-round. During hurricane season, I-75 becomes the primary evacuation route for the entire Gulf Coast, and a Cat 3+ threatening Tampa Bay turns the 230-mile drive into 8+ hours of gridlock. When evacuation orders go into effect, I-75 is contraflowed north — you literally cannot drive south to Miami's agency. A retiree with a cruise departing from Barcelona cannot wait for the evacuation to clear. One agency. 22 million Floridians. And during hurricane season, the road to that agency runs the wrong direction."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing."
    />
  );
}